import React from 'react';
import fp from 'lodash/fp';

import {components} from '@arborian/narrf';

import {useGlobals} from 'ccm/components/Globals';
import AsyncDialogFilter from 'ccm/components/datatable/AsyncDialogFilter';

import {selectAllFacilities} from 'ccm/lib/selectors';

const {dt2} = components;

export function FacilityFilter({column, filter, onChangeFilter, ...props}) {
    const globals = useGlobals();
    const fetchOptions = () => globals.fetchAll('facility.FacilityCollection');
    const selector = fp.pipe([selectAllFacilities, fp.map('attributes.name')]);

    return (
        <AsyncDialogFilter
            title='Facility'
            column={column}
            filter={filter}
            onChangeFilter={onChangeFilter}
            selector={selector}
            fetchOptions={fetchOptions}
            {...props}
        />
    );
}

export default function FacilityColumn({
    id = 'col-facility',
    title = 'Facility',
    field = 'attributes.facility_name',
    FilterComponent = FacilityFilter,
    ...props
}) {
    return (
        <dt2.Column
            id={id}
            title={title}
            field={field}
            FilterComponent={FilterComponent}
            {...props}
        />
    );
}
